import api from "./baseApi";
import endpoints from "./endpoints";

export const login = async ({ identifier, password }) => {
  try {
    const res = await api.post(endpoints.auth.login, {
      identifier,
      password,
    });

    const { token, user } = res.data;

    localStorage.setItem("cvToken", token);
    localStorage.setItem("user", JSON.stringify(user));

    return user;
  } catch (err) {
    const message =
      err.response?.data?.message || "login failed";

    throw new Error(message);
  }
};